module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-2.96dc88ef.jpg";